import React, { Component } from "react";
export default class MetadataView extends Component {
  render() {
    let metadataInfo = Object.keys(this.props.data).map((meta, index) => {
      return (
        <li key={index}>
          {meta}: {this.props.data[meta] === null ? "" : this.props.data[meta]}
        </li>
      );
    });

    return <ul>{metadataInfo}</ul>;
  }
}



// WEBPACK FOOTER //
// ./src/components/itemscreens/MetadataView.js